import {css, StyleSheet} from 'aphrodite';
import React, {useEffect, useState} from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import HorizontalThrobber from 'ui-library/HorizontalThrobber';

import {BartenderLabelTemplate, bartenderRequestPreview, BartenderServer} from './BartenderUtil';

interface Props {
  bartenderServer: BartenderServer;
  labelTemplate: BartenderLabelTemplate;
  labelParams: {[param: string]: string};
}

export default function BartenderPrintPreview(props: Props): JSX.Element {
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let canceled = false;
    const abortController = new AbortController();
    setPdfUrl(null);
    setError(null);
    bartenderRequestPreview({
      bartenderBaseUrl: props.bartenderServer.url,
      abortController,
      labelTemplate: props.labelTemplate,
      labelParams: props.labelParams,
    })
      .then((pdfUrl: string) => {
        if (!canceled) {
          setPdfUrl(pdfUrl);
        }
      })
      .catch((reason: unknown) => {
        if (!canceled) {
          setError(String(reason).toString());
        }
      });

    return function cleanup() {
      // Avoid "Warning: Can't perform a React state update on an unmounted component...."
      canceled = true;
      abortController.abort();
    };
  }, [props.labelTemplate, props.labelParams, props.bartenderServer.url]);

  if (pdfUrl != null) {
    return (
      <iframe
        title="Label PDF"
        src={`${pdfUrl}#view=Fit`}
        width="546"
        height="404"
        className={css(styles.borderWidth0)}
        {...getTestProps({component: 'BartenderPrintPreview', element: 'iframe'})}
      />
    );
  } else if (error != null) {
    return <div>Error loading preview: {error}</div>;
  } else {
    return <HorizontalThrobber />;
  }
}

export const styles = StyleSheet.create({
  borderWidth0: {
    borderWidth: 0,
  },
});
